import { Directive, Input, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appRole]',
    standalone: false
})
export class RoleDirective implements OnInit {
  // @Input('appRole') roles: string[]; // Accept roles as input
  roles = "spc-support,spc-key,spc-factory-supervisor,spc-line-supervisor,spc-production-admin,spc-sitekey"; //these roles have all tha access rest other restricted
  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    const userRole = localStorage.getItem('userRole'); // Assuming you have a method to get the user role 
    if (!this.roles.includes(userRole)) {
      this.renderer.setStyle(this.el.nativeElement, 'pointer-events', 'none');
      this.renderer.addClass(this.el.nativeElement, 'blurred');
    }
  }

}
